import { css } from "@emotion/react";
import StaffInfo from "./StaffInfo";
import {
  okamotoTakaya,
  tsuthiyaYusaku,
  morimotoKozueko,
  nakahara,
  makiyama,
  suzuki,
} from "./staff";

const Staff: React.FC = () => {
  return (
    <>
      <div css={topWhiteSpaceStyle}></div>
      <div css={mainStyle} id="staff">
        <div css={containerStyle}>
          <div css={contentsWrapper}>
            <div css={upperTitleWrapperStyle()}>
              <div css={borderStyle}></div>
              <div css={titleStyle}>スタッフ</div>
              <div css={borderStyle}></div>
            </div>
            <StaffInfo
              staffFileName="okamoto-takaya.png"
              alt="【脚本・演出】岡本 貴也"
              imgWidth={177}
              txt={okamotoTakaya}
              textBoxHeight={180}
              isTop
            />
            <StaffInfo
              staffFileName="tsuthiya-yusaku.png"
              alt="【音楽監督】土屋 雄作"
              imgWidth={158}
              txt={tsuthiyaYusaku}
            />
            <StaffInfo
              staffFileName="nakahara-hiroaki.png"
              alt="【演奏】中原 裕章"
              imgWidth={125}
              txt={nakahara}
            />
            <StaffInfo
              staffFileName="makiyama-haruna.png"
              alt="【演奏】まきやま はる菜"
              imgWidth={170}
              txt={makiyama}
            />
            <StaffInfo
              staffFileName="suzuki-rikako.png"
              alt="【演奏】鈴木 梨花子"
              imgWidth={138}
              txt={suzuki}
              isBottom
            />
            <div css={bottomBorderWrapperStyle}>
              <div css={borderStyle}></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const primaryColor = "#DD6B74";

const topWhiteSpaceStyle = css`
  width: 100%;
  height: 20px;
  background-color: #fff;
`;

const mainStyle = css`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const containerStyle = css`
  width: 100%;
  max-width: 500px;
  padding: 10px 20px 20px;
  @media (min-width: 768px) {
    padding: 0px 30px 30px;
  }
`;

const contentsWrapper = css`
  padding-bottom: 30px;

  @media (min-width: 768px) {
    margin-top: 5px;
    border: 1px solid ${primaryColor};
  }
`;

const upperTitleWrapperStyle = (isNoPaddingBottom?: boolean) => css`
  display: flex;
  align-items: center;
  padding: 30px 30px 20px;
  ${isNoPaddingBottom && `padding-bottom: 0;`}
`;

const bottomBorderWrapperStyle = css`
  padding: 0 30px;
  display: flex;
  align-items: center;
`;

const borderStyle = css`
  height: 1px;
  background-color: ${primaryColor};
  flex-grow: 1;
`;

const titleStyle = css`
  margin: 0 10px;
  font-size: 12pt;
  font-weight: 500;
`;

export default Staff;
